import { useState } from "react";
import api from "../api/axios";
import AppShell from "../components/AppShell";

export default function ChangePassword() {
  const [form, setForm] = useState({ currentPassword: "", newPassword: "", confirmPassword: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  const updateField = (field, value) => setForm((current) => ({ ...current, [field]: value }));

  const submit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    if (form.newPassword.length < 6) {
      setError("New password must be at least 6 characters.");
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError("New password and confirmation do not match.");
      return;
    }

    setSaving(true);
    try {
      const { data } = await api.put("/auth/change-password", {
        currentPassword: form.currentPassword,
        newPassword: form.newPassword,
      });
      setMessage(data.message || "Password updated successfully.");
      setForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    } catch (err) {
      setError(err.response?.data?.message || "Could not update password.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <AppShell>
      <div style={styles.header}>
        <div>
          <div style={styles.eyebrow}>SETTINGS</div>
          <h1 style={styles.title}>Change password</h1>
          <p style={styles.subtitle}>Update the password used to access your SHAHA Group account.</p>
        </div>
      </div>
      <section style={styles.panel}>
        <form onSubmit={submit} style={styles.form}>
          <Field label="Current password" value={form.currentPassword} onChange={(value) => updateField("currentPassword", value)} />
          <Field label="New password" value={form.newPassword} onChange={(value) => updateField("newPassword", value)} />
          <Field label="Confirm new password" value={form.confirmPassword} onChange={(value) => updateField("confirmPassword", value)} />
          {error && <div style={styles.error}>{error}</div>}
          {message && <div style={styles.success}>{message}</div>}
          <button type="submit" disabled={saving} style={styles.primary}>{saving ? "Updating..." : "Update password"}</button>
        </form>
      </section>
    </AppShell>
  );
}

function Field({ label, value, onChange }) {
  return (
    <label style={styles.label}>
      {label}
      <input type="password" required value={value} onChange={(event) => onChange(event.target.value)} style={styles.input} />
    </label>
  );
}

const styles = {
  header: { marginBottom: 24 },
  eyebrow: { color: "var(--signal)", fontSize: 11, letterSpacing: 1.5, fontWeight: 700 },
  title: { fontFamily: "var(--font-display)", fontSize: 30, margin: "5px 0 0" },
  subtitle: { color: "var(--slate-500)", fontSize: 14, marginTop: 6 },
  panel: { width: "100%", maxWidth: 520, background: "var(--white)", border: "1px solid var(--line)", borderRadius: "var(--radius)", padding: 24 },
  form: { display: "flex", flexDirection: "column", gap: 16 },
  label: { display: "flex", flexDirection: "column", gap: 6, color: "var(--ink)", fontSize: 13 },
  input: { border: "1px solid #c7d5e8", borderRadius: 4, padding: "10px 12px", color: "var(--ink)", fontSize: 14 },
  error: { color: "#a8402c", background: "rgba(217,99,78,.1)", border: "1px solid var(--danger)", padding: "10px 12px", borderRadius: 4, fontSize: 13 },
  success: { color: "#24734d", background: "rgba(79,169,122,.12)", border: "1px solid var(--ok)", padding: "10px 12px", borderRadius: 4, fontSize: 13 },
  primary: { background: "var(--brand-gradient)", color: "var(--white)", border: 0, borderRadius: 4, padding: "11px 16px", fontWeight: 600 },
};